<template>
    <div class="newdeviceControl">
        <div class="con">
             <div class="mytable" style="margin-bottom:8px">
                <div class="mybox">
                    <div class="search-input-btn" style="width:100%">
                    <el-scrollbar style="height:100%;width: 100%;">
                        <div class="my-search-i">
                        <div class="input-small mr-20">
                            <span>状态：</span>
                            <el-checkbox v-model="boxList.status" ></el-checkbox>
                        </div>
                        <div class="input-small mr-20">
                            <span>总寿命次数：</span>
                            <el-input v-model="boxList.defaultTotal" clearable placeholder="请输入总寿命次数" ></el-input>
                        </div>
                        <div class="input-small mr-20">
                            <span>告警阈值(%)：</span>
                            <el-input v-model="boxList.thresholdRate" clearable placeholder="请输入告警阈值(%)" @change="ratefun"></el-input>
                        </div>
                        <div class="input-small  mr-20">
                            <span>告警阈值：</span>
                            <el-input v-model="boxList.thresholdValue" disabled ></el-input>
                        </div>
                         <div class="input-small  mr-20">
                            <span>web通知：</span>
                            <el-checkbox v-model="boxList.webMessage" ></el-checkbox>
                        </div>
                         <div class="input-small">
                            <span>短信通知：</span>
                            <el-checkbox v-model="boxList.mobileMessage" ></el-checkbox>
                        </div>
                         
                        </div>
                       
                    </el-scrollbar>
                    </div>
                    <el-button type="primary"  @click="boxChang" class="search-btn">保存</el-button>
                </div>
            </div>
            <div class="mytable2">
                   <div class="table-top">
                       <div class="left-search">
                                <span>名称：</span>
                                <el-input v-model="searchName" clearable placeholder="请输入系统名称"></el-input>
                                 <el-button type="primary" plain  class="search-btn" @click="getDeviceList">查询</el-button>
                       </div>
                       <div class="btns">
                           <el-button type="primary"  @click="addDrawer">添加</el-button>
                           <el-button type="danger"  class="last-el-button" @click="del_fn">删除</el-button>
                       </div>
                   </div>
                    <div class="mytable3" :style="{'height':heights+'px'}">
                   <el-table id="demo" :height="heights - 20" border v-loading="loading" stripe :data="tableData" @selection-change="handleSelectionChange"  style="width: 100%">
                     <template slot="empty">
                        <span class="noData">
                          <img src="@/assets/noData.png" alt="暂无数据">
                          <span class="text">暂无数据</span>
                        </span>
                      </template>
                       <el-table-column
                           type="selection"
                           width="44" align="center">
                        </el-table-column>
                      <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                      
                      <el-table-column label="设备名"  prop="deviceName" min-width="150"></el-table-column>
                       <el-table-column label="设备编号"  prop="deviceNo" min-width="150"></el-table-column>
                       <el-table-column label="变量名"  prop="variableName" min-width="150"></el-table-column>
                       <el-table-column label="总寿命次数"  prop="initialOperations" min-width="150" align="center"></el-table-column>
                       <el-table-column label="使用次数"  prop="useOperations" min-width="150" align="center"></el-table-column>
                       <el-table-column label="剩余次数"  prop="surplusOperations" min-width="150" align="center"></el-table-column>
                       <el-table-column label="操作" align="center" width="200">
                        <template #default="{row}">
                          <div class="btnss" style="display: flex;justify-content: center; align-items: center;">
                             <div @click="edit_ed(row)" >
                                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                  <elIconBtn btnType='edit'></elIconBtn>
                                </el-tooltip>
                              </div>
                          </div>
                        </template>
                      </el-table-column>
                  </el-table>
                    </div>
                     <div class="divider-line"></div>
                  <div class="paging">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                        background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
            </div>

            <el-drawer title="" :visible.sync="drawer" :with-header="false"  :size="drawerSize">
                   <div class="drawer-con">
                      <div class="Files-top">
                        <div class="ic-left"><span>设备列表</span></div>
                        <div class="btns">
                            <el-button type="primary" class="last-el-button" @click="drawerAdd">确定</el-button>
                        </div>
                      </div>
                      <div class="dracaozuo" style="display:flex">
                          <div class="dratree" :style="{'width':'400px','height':`${heights+260}px`}">
                               <div class="search" style="margin-top:10px">
                                  <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                                </div>
                                <el-scrollbar style="height:calc(100% - 40px);width: 100%;">
                                  <el-tree class="filter-tree" :data="treeList" show-checkbox node-key="keyId" :props="defaultProps2"
                                       @check="currentChecked"
                                        highlight-current
                                        ref="tree">
                                        <span class="custom-tree-node" slot-scope="{node}">
                                            <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;"
                                            v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'" />

                                            <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;"
                                            v-if="node.data.Content.variableName" />

                                            <img src="../../../public/static/image/elTree/2.1.png"
                                            style="margin-right: 2px; position: relative;top: 1px;"
                                            v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'" />
                                            <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
                                        </span>
                                        </el-tree>

                                  </el-scrollbar>
                          </div>
                         </div>
                   </div>

            </el-drawer>
            <!-- 修改 -->
            <el-dialog width="450px" v-dialogDrag :title="textMap" :close-on-click-modal='false'
                :visible.sync="dialogVisible">
                <div style="display: flex;">
                <el-form :model="temp" ref="temp"  style="width: 100%;height: 80px;padding-top: 10px;">
                    <el-form-item label="总寿命次数：" prop="initialOperations">
                    <el-input v-model="temp.initialOperations" style="width:240px"></el-input>
                    </el-form-item>
                </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="edit_fn">确 定</el-button>
                </div>
            </el-dialog>
            
        </div>
    </div>
</template>

<script>
import {findControlManage,findDeviceList,saveControlManage,saveDevices,updateDevice,removeDevice} from "../../api/abbNewApi";
import {statementVariableTree} from "../../api/newReport";
import elIconBtn from '@/components/module/iconBtns.vue'
import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
export default {
    components: {
        elUnitTree,
        elIconBtn
    },

    data() {
        return {
            boxList:{},
            heights: document.getElementById('app').clientHeight-350,
            loading: false,
            tableData:[],
            searchName:"",
             total: 0,
            currentPage: 1,
            currentSize: 15,
            dialogVisible: false,
            temp:{},
            defaultProps2: {
                children: 'ChildDatas',
                label: 'Content.Name'
            },
            treeList: [],
            drawerSize:"424px",
            drawer: false,
            filterText:"",
            checked:false,
            checkedNodes:[],
            textMap:"修改",
            multipleSelection:[],
        };
    },
    computed:{
       
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
    },

    mounted() {
        this.getTree()
        this.getList()
        this.getDeviceList()
    },
    watch :{
        nowUnit(){},
    },

    methods: {
        //改变阈值(%)的时候，也要算出阈值
        ratefun(val){
           this.boxList.thresholdValue = parseInt(this.boxList.defaultTotal * (val / 100))
        },
        //保存上面
        boxChang(){
             if( this.boxList.thresholdRate > 100){
               this.$message({type: 'warning',message: '告警阈值(%)不能大于100% !'});
               return
          }
            var d  = {
                 "createTime": this.boxList.createTime,
                "defaultTotal": this.boxList.defaultTotal,
                "id": this.boxList.id,
                "mobileMessage": this.boxList.mobileMessage ? 'ENABLE' : 'DISABLE',
                "status": this.boxList.status ? 'ENABLE' : 'DISABLE',
                "thresholdRate": this.boxList.thresholdRate,
                "thresholdValue": parseInt(this.boxList.defaultTotal * (this.boxList.thresholdRate / 100)),
                "webMessage": this.boxList.webMessage ? 'ENABLE' : 'DISABLE'
            }
            saveControlManage(d).then(res => {
                if(res.code == 200) {
                     var data = res.data
                    data.webMessage = data.webMessage == 'ENABLE' ? true : false
                    data.status = data.status == 'ENABLE' ? true : false
                    data.mobileMessage = data.mobileMessage == 'ENABLE' ? true : false
                    this.boxList = res.data
                    this.$message({showClose: true,message: '保存成功',type: 'success'});
                }else {
                     if(res.message) {
                        this.$message.error(res.message);
                        } else {
                        this.$message.error('保存失败');
                        }
                }
            })

        },
        //树形结构选中
        currentChecked (val,SelectedObj) {
            var mychangData = SelectedObj.checkedNodes
            this.checkedNodes =mychangData.filter(item => !item.hasOwnProperty('ChildDatas'))

        },
        //添加设备弹窗
        addDrawer(){
           if(this.boxList.defaultTotal <= 0 || this.boxList.defaultTotal==''){
              this.$message({showClose: true,message: '总寿命次数不能小于等于0！',type: 'warning'});
              return
           }
           this.drawer = true
        },
        
        //保存设备控制列表
        drawerAdd(){
            if( this.checkedNodes.length ==0){
               this.$message({type: 'warning',message: '请勾选需要添加的设备变量!'});
               return
          }
            var d = []
            this.checkedNodes.forEach(item => {
               d.push({
                 "deviceName": item.deviceList.deviceNames,
                "deviceNo":  item.deviceList.deviceIds,
                "variableName":  item.Content.variableName
               })
            })
            saveDevices(d).then(res => {
                 if(res.code == 200) {
                     this.getDeviceList()
                     this.$message({showClose: true,message: '添加成功',type: 'success'});
                 }else {
                     if(res.message) {
                        this.$message.error(res.message);
                        } else {
                        this.$message.error('添加失败');
                        }
                }
            })

        },
        //修改设备控制的总寿命次数
        edit_ed (v) {
            // this.textMap = 
            this.temp=Object.assign({},v);
            this.dialogVisible=true;
            this.$nextTick(() => {
            this.$refs["temp"].clearValidate();
            });
        },
        //确定修改
        edit_fn(){

           var d = {
             "id":this.temp.id,
             "initialOperation":this.temp.initialOperations
           }
           updateDevice(d).then(res => {
              if(res.code == 200){
                 this.getDeviceList()
                  this.$message({showClose: true,message: '修改成功',type: 'success'});
                  this.dialogVisible=false;
              }else {
                     if(res.message) {
                        this.$message.error(res.message);
                        } else {
                        this.$message.error('修改失败');
                        }
                }
           })
        },
        //表格选中
         handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //删除
        del_fn(){
          if( this.multipleSelection.length ==0){
               this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
               return
          }
          var ids = ""
          this.multipleSelection.forEach(item => ids += ','+item.id)
          // console.log(ids.split(1));
          var myids = ids.slice(1)
          // console.log(v);
            this.$confirm('是否删除选中的设备','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            removeDevice({'ids':myids}).then(res => {
                if(res.code == 200){
                    this.getDeviceList()
                    this.$message({showClose: true,message: '删除成功',type: 'success'})
                }else {
                        if(res.message) {
                            this.$message.error(res.message);
                            } else {
                            this.$message.error('修改失败');
                            }
                    }
            })
            }).catch(() => {
            // ...
            });
          

        },
        getList(){
            findControlManage().then(res => {
                if(res.code == 200){
                        var data = res.data
                        data.webMessage = data.webMessage == 'ENABLE' ? true : false
                        data.status = data.status == 'ENABLE' ? true : false
                        data.mobileMessage = data.mobileMessage == 'ENABLE' ? true : false
                        this.boxList = res.data
                        
                }else {
                        if(res.message) {
                        this.$message.error(res.message);
                        } else {
                        this.$message.error('查看失败');
                        }
                }
               

            })
        },
        //获取下面的设备表格数据
        getDeviceList(){
            var d  = {
              pageNum:this.currentPage,
              pageSize:this.currentSize,
            }
            if(this.searchName != ""){
               d.deviceName = this.searchName
            }
            this.loading = true
            findDeviceList(d).then(res => {
               this.loading = false
               if(res.code ==200){
                  this.tableData = res.data.content
                    this.total=res.data.totalElements;
               }else {
                        if(res.message) {
                        this.$message.error(res.message);
                        } else {
                        this.$message.error('查看失败');
                        }
                }
            })
        },

        //获取变量设备树
        getTree(){
             statementVariableTree({"unitId": this.nowUnit.id}).then(res => {
                if(res.code==200) {
                    this.handleData(res)
                }
            })
        },
         //处理企业数据
        handleData (data) {
            data=JSON.parse(JSON.stringify(data).replace(/appTypes/g,'ChildDatas').replace(/groupName/g,"Name").replace(/groupIdAndName/g,"Content").replace(/groupId/g,"Id").replace(/appTypeInfo/g,"Content").replace(/appName/g,"Name"))
            var filterArr = []
            var recursiveFunction=function() {
            const getStr=function(list) {
                list.forEach(function(row) {
                if(row.ChildDatas.length!=0) {

                    getStr(row.ChildDatas)
                } else {
                    if(row.Content.groups != null){
                        filterArr = row.Content.groups.filter(v => v.Content.Name=='开关状态')
                    
                        // row.ChildDatas=filterArr
                        if(filterArr.length != 0){
                          
                          filterArr[0].ChildDatas = filterArr[0].ChildDatas.filter(val => val.Content.Name =='开关量')
                          filterArr[0].ChildDatas.forEach(t => {
                             t.deviceList = {
                                "deviceNames":row.Content.Name,
                                "deviceIds":row.Content.Id,
                             }
                          })

                            row.ChildDatas=filterArr
                        }else {
                            row.ChildDatas = []
                        }
                        row.Content.groups = []
                    }
                }
                })
            }
            getStr([data.data])
            }
            recursiveFunction()
            this.treeList=[data.data];
            // this.treeListCopy=this.treeList
        },

       

         handleSizeChange (val) {
        this.currentSize=val;
        this.getDeviceList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.getDeviceList();
      }
    },
};
</script>

<style lang="scss" scoped>
.newdeviceControl{
    /deep/.el-checkbox__input {
        position: relative;
        top: 1px;
    }
   .con {
      width: 100%;
      height: 100%;
      .mytable {
         width: 100%;
         height: 120px;
         padding: 12px;
         box-sizing: border-box;
         background-color: #fff;
         .mybox {
            width: 100%;
            height: 100%;
            border: 1px solid #ccc;
            display: flex;
            align-items: center;
            position: relative;
            .search-input-btn {
                margin: 0px;
                margin-left: 12px;
                // position: relative;
                margin-right: 120px;
              
            }
              .search-btn {
                    position: absolute;
                    top: 50%;
                    right: 0px;
                    transform: translateY(-50%);
                }
         }
      }
      .drawer-con {
        padding: 12px 20px 20px 20px;
        }
      .mytable2 {
        width: 100%;
        height: calc(100% - 128px);
        padding: 12px;
         box-sizing: border-box;
         background-color: #fff;
         .table-top {
             width: 100%;
             height: 36px;
             display: flex;
             align-items: center;
             justify-content: space-between;
             margin-bottom: 12px;
             .left-search {
                width: 392px;
                display: flex;
                align-items: center;
                span {
                    white-space: nowrap;
                }
             }
         }
      }
      .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
      }
       /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }
  
    
   }
}
</style>